<template>
  <div>
    <h5>RECENT COMMUNICATIONS</h5>
    <div class="order-setupitem-notes" v-if="hasLogEntries">
      <p v-for="activityLog of topCommLog" :key="activityLog.id">
        <a class="order-commlog-link" v-if="activityLog.communicationLog" @click.prevent="viewCommunicationLog(activityLog)" href="#">
          {{activityLog.message}} at {{activityLog.createdAt | formatDateTime}}
        </a>
        <template v-if="!activityLog.communicationLog">
          {{activityLog.message}} at {{activityLog.createdAt | formatDateTime}}
        </template>
      </p>
      <p v-if="extraCommLogCount > 0">+{{extraCommLogCount}} extra log{{extraCommLogCount | displayCountPlural}}</p>
    </div>
    <p v-if="!hasLogEntries">No communications</p>
  </div>
</template>

<style scoped>
.order-commlog-link {
  color: inherit;
}
.order-commlog-link:hover {
  text-decoration: underline;
}
</style>

<script>
import buildUrl from 'build-url'

import CommunicationLogDialog from '@/modules/communication/views/communicationLogDialog'

export default {
  name: 'OrderCommLogList',
  props: {
    orderId: Number
  },
  data() {
    return {
      logLimit: 3,
      emailList: []
    }
  },
  computed: {
    topCommLog() {
      if(this.emailList.length > this.logLimit)
        return this.emailList.slice(0, this.logLimit)
      return this.emailList
    },
    extraCommLogCount() {
      return Math.max(this.emailList.length - this.logLimit, 0)
    },
    hasLogEntries() {
      return this.emailList.length > 0
    }
  },
  watch: {
    orderId: {
      immediate: true,
      handler: function () {
        this.requestData()
      }
    }
  },
  methods: {
    reloadData() {
      this.requestData()
    },
    requestData() {
      if(!this.orderId)
        return
      this.emailList = []

      var filter = {
        'filter[activityType]': 'emailed'
      }
      let url = `/orders/${this.orderId}/activitystream?` + this.buildQueryParams(filter)
      this.$api.get(url)
      .then(response => {
        this.emailList = response.data.data
      })
      .catch(err => {
      })
    },
    viewCommunicationLog(activityItem) {
      if(!activityItem.communicationLog)
        return
      this.displayModal(CommunicationLogDialog, { 
        communicationLogId: activityItem.communicationLog.id
      })
      .then(() => { })
    }
  }
}
</script>